function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import { TAB_CLICKED } from "/constants/bigbrain-event-types";
import Colors from "styles/colors";
import { StyledTab } from "./tab.scss";
import DefaultProps from "./default-props";
import PictureComponent from "components/core/picture/picture-component";
import { themes } from "segments/segments-service";
import { WHITE_COLOR_NAME, BRAND_BLACK_BACKGROUND_COLOR } from "styles/color-consts";
class Tab extends PureComponent {
    onTabClicked(e) {
        this.blurTab(e);
        this.tabClickedAction();
    }
    getTabColor() {
        const { disabledColor, color, isDarkTheme, isDisabled, isActive } = this.props;
        if (isDisabled && disabledColor) return Colors[disabledColor];
        return isActive ? Colors[color] : isDarkTheme ? Colors[WHITE_COLOR_NAME] : Colors[BRAND_BLACK_BACKGROUND_COLOR];
    }
    render() {
        const { tabImage, isActive, color, theme, tabClassName } = this.props;
        const leftBorderColor = theme ? themes[theme].background : "none";
        return /*#__PURE__*/ _jsxs(StyledTab, {
            color: color,
            className: classnames("vertical-tab", {
                active: isActive,
                "with-image": tabImage,
                [tabClassName]: tabClassName
            }),
            onClick: this.onTabClicked,
            role: "tab",
            "aria-selected": isActive,
            tabIndex: 0,
            onKeyDown: this.onKeyDown,
            style: {
                "--border-color": leftBorderColor
            },
            children: [
                !tabImage && this.rednerWithoutImage(),
                tabImage && this.rednerWithImage()
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "blurTab", (e)=>{
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".vertical-tab")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        _define_property(this, "tabClickedAction", ()=>{
            const { onClick, index, label } = this.props;
            BigBrain("track", TAB_CLICKED, {
                kind: label,
                info1: index
            });
            onClick(index);
        });
        _define_property(this, "rednerWithImage", ()=>{
            const { tabImage } = this.props;
            return /*#__PURE__*/ _jsx("div", {
                className: "tab-image",
                children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, tabImage))
            });
        });
        _define_property(this, "rednerWithoutImage", ()=>{
            const { label, isActive, color, addTimeline, lineColor } = this.props;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    addTimeline && /*#__PURE__*/ _jsx("hr", {
                        className: "vertical-tab-timeline",
                        style: {
                            borderColor: isActive ? Colors[color] : Colors[lineColor] || Colors[WHITE_COLOR_NAME]
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "tab-label",
                        style: {
                            color: this.getTabColor()
                        },
                        children: label
                    })
                ]
            });
        });
        this.onTabClicked = this.onTabClicked.bind(this);
        this.onKeyDown = generateOnKeyDownHandler(this.tabClickedAction);
    }
}
export { Tab as default };
Tab.defaultProps = DefaultProps;
